import { Icon as LegacyIcon } from '@ant-design/compatible';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(() => ({
	button: {
		flexShrink: 0,
		color: "#fff",
		textTransform: "capitalize",
		borderRadius: 4,
		background: "linear-gradient(to left, #27272F, #27272F 80%)",
		height: 40,
		padding: "0 30px",
		boxShadow: "none",
		fontSize: 14,
		transitionDuration: "0.25s !important",

		"&:hover": {
			background: "linear-gradient(to left, #27272F, #27272F 80%)",
			boxShadow: "none",
		},

		"&:disabled > .MuiButton-label": {
			color: "#aaa !important",
		},
		"&:disabled": {
			background:
				"repeating-linear-gradient(-45deg, transparent, transparent 3px, #e4e4e4 3px, #e4e4e4 8px ), linear-gradient(to bottom, #eee, #eee)",
			boxShadow: "none",
			cursor: "not-allowed",
		},
	},
}));

/**
 * Renders a custom primary button component.
 *
 * @param {Object} props - The props object.
 * @param {boolean} props.loading - Indicates if the button is in a loading state.
 * @param {boolean} props.disabled - Indicates if the button is disabled.
 * @param {string} props.className - Additional CSS class names for the button.
 * @param {Function} props.buttonClick - The click event handler for the button.
 * @param {string} props.icon - The icon to be displayed on the button.
 * @param {string} props.iconType - The type of the icon.
 * @param {string} props.iconTheme - The theme of the icon.
 * @param {string} props.label - The label text for the button.
 * @param {"reset"|"submit"|"button"} props.type - The label text for the button.
 * @returns {JSX.Element} The rendered custom primary button component.
 */
export default function CustomPrimaryButton(props) {
	const classes = useStyles();
	return (
        <Button
			style={props.style || {}}
			disabled={props.disabled || props.loading}
			variant="contained"
			color="primary"
			className={`${classes.button} ${props.className}`}
			onClick={(event) => props.buttonClick?.(event.currentTarget)}
			startIcon={
				props.icon ? (
					<LegacyIcon
						type={props.iconType}
						theme={props.iconTheme ? props.iconTheme : null}
					/>
				) : null
			}
			type={props.type || "button"}
		>
			{props.loading ? (
				<i
					className="fa fa-refresh"
					style={{
						animation: "spin 1s infinite linear",
					}}
				/>
			) : (
				props.label
			)}
		</Button>
    );
}
